module.exports = __webpack_public_path__ + "static/img/GNSS03.f9bffa8d.png";